import HistoryEntryType from "@/models/Shared/HistoryEntryType";

export default (value: HistoryEntryType) => {
   switch(value) {
       case HistoryEntryType.Add: {
           return "Added";
        }
        case HistoryEntryType.Remove: {
           return "Removed";
        }
       case HistoryEntryType.Create: {
            return "Created";
        }
        case HistoryEntryType.Delete: {
            return "Deleted";
        }
        case HistoryEntryType.Update: {
            return "Updated";
        }
        default: {
            return "Unknown action";
        }
   }
}